import { customAlphabet } from 'nanoid'

const ALPHANUMERIC_ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

export const createId = customAlphabet(ALPHANUMERIC_ALPHABET, 21)
